import { designerEngine } from "../engine/DesignerEngine";
import TextControls from "./TextControls";

export default function TextPanel() {
  const addText = () => {
    designerEngine.addText("Your Text");
  };

  return (
    <div className="space-y-4">
      <button
        onClick={addText}
        className="w-full bg-cyan-600 hover:bg-cyan-500 py-3 rounded-xl font-semibold text-white"
      >
        ✍ Add Text
      </button>

      <div className="rounded-xl bg-slate-800 border border-slate-700 p-4">
        <h3 className="text-white font-semibold mb-3">Text style</h3>
        <TextControls />
      </div>

      <p className="text-slate-500 text-[11px]">Tip: double-click the text on the shirt to retype it.</p>
    </div>
  );
}
